var booking = {
    //设置预订类型bookingType，normal：普通，xCabin：x舱预售
    setBookingType: function(bookingType){
        localStorage.removeItem("passengers");
        //各种预订类型对应的信息
        var typeParams = {
            'normal': {
                maxPsgNum: 9
            },
            'xCabin': {
                maxPsgNum: 1
            }
        }
        sessionStorage.setItem('bookingType' ,bookingType);
        sessionStorage.setItem('maxPsgNum' ,typeParams[bookingType].maxPsgNum);
    },
    //最大乘机人数
    getMaxPsgNum: function(){
        var ret = sessionStorage.getItem('maxPsgNum');
        if(!ret || ret == 'undefined'){
            return 9;
        }
        else{
            return parseInt(ret);
        }
    },
    getBookingType: function(){
        var ret = sessionStorage.getItem('bookingType');
        if(!ret || ret == 'undefined'){
            return 'normal';
        }
        else{
            return ret;
        }
    },
    setActivityId: function(activityId){
        sessionStorage.setItem('activityId', activityId);
    },
    setActivityTid: function(activityTid){
        sessionStorage.setItem('activityTid', activityTid);
    },
    getActivityId: function(){
        return sessionStorage.getItem('activityId');
    },
    getActivityTid: function(){
        return sessionStorage.getItem('activityTid');
    },
}
export default booking;


// WEBPACK FOOTER //
// ./src/assets/js/booking.js